// extracted by mini-css-extract-plugin
export default {"section":"UfoFormSection_section__mPjVu"};